if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('custom-cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') || document.querySelector('custom-cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      /* Color pack (product-qty-discount.liquid): several colors in one add */
      const packFn = this.form.qtyPackGetItems;
      const pack = typeof packFn === 'function' ? packFn() : null;
      if (pack && pack.active && !pack.ok) {
        this.handleErrorMessage(pack.message || 'Bitte Pack vervollständigen');
        return;
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        let addRequest;
        if (pack && pack.active && pack.ok) {
          const body = { items: pack.items };
          if (this.cart) {
            body.sections = this.cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
          }
          addRequest = fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body),
          });
        } else {
          addRequest = fetch(`${routes.cart_add_url}`, config);
        }

        addRequest
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

          const discountCode = (this.form.dataset.qtyDiscountCode || '').trim();
          const finishAdd = (cartState) => {
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: cartState,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(cartState) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(cartState);
            }
          };

          if (!discountCode) {
            finishAdd(response);
            return;
          }

          const existingCodes = (response.discount_codes || [])
            .filter((code) => code && code.code && code.applicable !== false)
            .map((code) => code.code);
          if (!existingCodes.some((code) => code.toLowerCase() === discountCode.toLowerCase())) {
            existingCodes.push(discountCode);
          }

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin',
            body: JSON.stringify({
              discount: existingCodes.join(','),
              sections: this.cart.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname,
            }),
          })
            .then((discountedCart) => discountedCart.json())
            .then((discountedCart) => finishAdd(discountedCart))
            .catch(() => finishAdd(response));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
  });
}
